/** Helper to roud a number to 2 decimal points */
export function Money(value: number): number {

    if(!Number.isFinite(value)){
        return value
    }

    const stringNumber = value.toString();
    const threeNumbersAfterDot = stringNumber.match(/\.\d{3}/g)?.[0];

    let lastNumberOfExpressionIsHigherThanOrEqualToFive: boolean;
    let fixedNumber: number = value;
    const valueIsNegative = value < 0;

    if (threeNumbersAfterDot?.length) {
        const lastNumberOfExpression = +threeNumbersAfterDot[3];
        if (!isNaN(lastNumberOfExpression)) {
            lastNumberOfExpressionIsHigherThanOrEqualToFive = lastNumberOfExpression >= 5;
        }

        fixedNumber = value + ((.005 * (lastNumberOfExpressionIsHigherThanOrEqualToFive ? 1 : -1)) * (valueIsNegative ? -1 : 1)); 
    }
    return Number(fixedNumber.toFixed(2));
}